import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DestroyRef, ErrorHandler, inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class CleverErrorHandler implements ErrorHandler {
    destroyRef = inject(DestroyRef);
    constructor(@Inject(PLATFORM_ID) private platformId: any, private http: HttpClient) {
    }

    handleError(error: any): void {
        if (isPlatformBrowser(this.platformId)) {
            this.handleBrowser(error);
        } else {
            this.handleServer(error);
        }
    }

    handleBrowser(error: any): void {
        // Handle the client/browser side exceptions
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': ''
            })
        };
        this.http.post('api/log/newerror', { body: {error: error.stack, from: 'browser'}}, httpOptions).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((_) => {
            console.log(error);
        });
    }

    handleServer(error: any): void {
        // Handle the server-side exceptions
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': ''
            })
        };
        this.http.post('api/log/newerror', { body: {error: error.stack, from: 'server'}}, httpOptions).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((_) => {
            console.log(error);
        });
    }
}